// src/CheckinForm.jsx
import React, { useEffect, useState, useRef } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  TextField,
  Button,
  Switch,
  FormControlLabel,
  RadioGroup,
  Radio,
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails 
} from '@mui/material';
import Link from '@mui/material/Link';

import { useNavigate } from 'react-router-dom';

// MUI Icons
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import EmailIcon from '@mui/icons-material/Email';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import MapIcon from '@mui/icons-material/Map';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import { mapboxaddressSearch } from '../../service/Address/searchaddress';
import { postOFIAttendee } from '../../service/OFI/addOFI';
import { getContactsByCommunicationDetail } from '../../service/Contacts/getContacts'; 
import ContactInspectionCard from './InspectionCard'; 

 import { getCurrentConfig } from '../../config/config';
 


const CheckinForm = ({ selectedOpenhome, attendeeDetails }) => { 
  
  const [selectedAttendee, setSelectedAttendee] = useState(attendeeDetails || []); 
  const [selectedfeedbackId, setselectedfeedbackId] = useState({ feedbackId: 0 });
  const [selectedcontactID, setselectedContactID] = useState({ contactId: 0 });


  const [openTimeDetails, setopenTimeDetails] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const scrollViewRef = useRef(null);
  const [searchAddressResults, setSearchAddressResults] = useState([]);
  const [attendeeOwnPropertyAddressExtraFields, setAttendeeOwnPropertyAddressExtraFields] = useState({
    attendeeOwnPropertyAddress: '',
    attendeeOwnPropertyAddressExcludeSuburbState: '',
    attendeeOwnPropertyLatitude: '',
    attendeeOwnPropertyLongitude: '',
    attendeeOwnPropertyPostcode: '',
    attendeeOwnPropertyState: '',
    attendeeOwnPropertyStreetName: '',
    attendeeOwnPropertyStreetNameExcludeSuburbState: '',
    attendeeOwnPropertySuburb: '',
    attendeeOwnPropertyUnitAndStreetNumber: '',
  });
  const [extraOpentimeDetails, setExtraOpentimeDetails] = useState({
    openTimeId: 0,
    primaryAgentId: 0,
    inspectionPropertyId: 0,
    propertyId: 0,
    dateUpdated: '',
    inspectionDate: '',
    inspectionTime: '',
    inspectionDateTime: '',
    inspectionProperty: '',
  });
  const [selectedAddress, setSelectedAddress] = useState('');
  const [contactResultsEmail, setContactResultsEmail] = useState([]);
  const [isSearchingMobile, setIsSearchingMobile] = useState(false);
  const [isSearchingEmail, setIsSearchingEmail] = useState(false);
  const [isSearchingMapbox, setIsSearchingMapbox] = useState(false);
  const [contactResultsMobile, setContactResultsMobile] = useState([]);
  const [isSendingDoc, setIsSendingDoc] = useState(false);
  const [isInpectionHistory, setIsInspectionHistory] = useState(false);
  const [isFeedback, setIsFeedback] = useState(false);
  const config = getCurrentConfig();
  const navigate = useNavigate();
  const privatepolicyURL = config.Shortname === 'BHGRE' ? 'https://www.bhgre.com.au/privacy-policy/' : 'https://www.century21.com.au/privacy-policy';
  const disclaimerURL = config.Shortname === 'BHGRE' ? 'https://www.bhgre.com.au/disclaimer/' : 'https://www.century21.com.au/disclaimer';
  const dateNow = new Date();
  const addressLabel = 'Street Name and Suburb';

  useEffect(() => {
    if (location.state?.item) {
        setSelectedAttendee(location.state.item);
    }
  }, [location.state?.item]); 
 


  useEffect(() => {
    if (selectedAttendee && selectedAttendee.feedbackid && selectedAttendee.contactid) {
      setselectedfeedbackId({ feedbackId: selectedAttendee.feedbackid });
      setselectedContactID({ contactId: selectedAttendee.contactid });
    } else {
        // Clear selected contact if no attendee is passed or it's a new entry
        setselectedfeedbackId({ feedbackId: 0 });
        setselectedContactID({ contactId: 0 });
    }
  }, [selectedAttendee]);


  useEffect(() => {
    const fetchOpentimes = async () => {
      setopenTimeDetails(selectedOpenhome);
    };
    fetchOpentimes();
  }, []);

  useEffect(() => {
    setExtraOpentimeDetails({
      openTimeId: openTimeDetails?.propertyopentimeid,
      primaryAgentId: openTimeDetails?.userid,
      inspectionPropertyId: openTimeDetails?.propertyid,
      propertyId: openTimeDetails?.propertyid,
      dateUpdated: dateNow.toISOString(),
      inspectionDate: openTimeDetails?.startDates,
      inspectionTime: openTimeDetails?.startTimes,
      inspectionDateTime: `${openTimeDetails?.startDates} ${openTimeDetails?.startTimes}`,
      inspectionProperty: `${openTimeDetails?.streetNumber} ${openTimeDetails?.streetName}, ${openTimeDetails?.suburb}`,
    });
  }, [openTimeDetails]);



  const searchAddressViaMapbox = React.useCallback(async (searchAddressText) => {
    if (searchAddressText && searchAddressText.length > 3) {
      setIsSearchingMapbox(true);
      let queryString = `q=${searchAddressText}`;
      let countryCode = openTimeDetails?.countryId === 152 ? 'NZ' : 'AU';

      if (openTimeDetails?.latitude && openTimeDetails?.longitude) {
        queryString = `${queryString}&proximity=${openTimeDetails?.longitude},${openTimeDetails?.latitude}&country=${countryCode}`;
      } else {
        queryString = `${queryString}&country=${countryCode}`;
      }

      try {
        const mapboxRes = await mapboxaddressSearch(queryString);
        if (mapboxRes.data && mapboxRes.data.length > 0) {
          setSearchAddressResults(mapboxRes.data);
        } else {
          setSearchAddressResults([]);
        }
      } catch (error) {
       
        setSearchAddressResults([]);
      } finally {
        setIsSearchingMapbox(false);
      }
    } else {
      setSearchAddressResults([]);
    }
  }, [openTimeDetails]);

  const populateAttendeeOwnPropertyAddressExtraFields = (propertyDetails, unitAndStreetNumber) => {
    let fullAddress = propertyDetails.full_address;
    let UandSNumber = unitAndStreetNumber;

    if (UandSNumber) {
      fullAddress = `${UandSNumber} ${fullAddress}`;
    }

    let suburbName = '';
    if (propertyDetails.context.locality) {
      suburbName = propertyDetails.context.locality.name;
    } else if (propertyDetails.context.place) {
      suburbName = propertyDetails.context.place.name;
    }

    setAttendeeOwnPropertyAddressExtraFields({
      attendeeOwnPropertyAddress: fullAddress,
      attendeeOwnPropertyAddressExcludeSuburbState: `${UandSNumber ? `${UandSNumber} ` : ''}${propertyDetails.full_address.split(',')[0]}`,
      attendeeOwnPropertyLatitude: propertyDetails.coordinates.latitude ?? '',
      attendeeOwnPropertyLongitude: propertyDetails.coordinates.longitude ?? '',
      attendeeOwnPropertyPostcode: propertyDetails.context.postcode.name ?? '',
      attendeeOwnPropertyState: propertyDetails.context.region.name ?? '',
      attendeeOwnPropertyStreetName: propertyDetails.full_address ?? '',
      attendeeOwnPropertyStreetNameExcludeSuburbState: propertyDetails.full_address.split(',')[0],
      attendeeOwnPropertySuburb: suburbName,
      attendeeOwnPropertyUnitAndStreetNumber: UandSNumber,
    });

    setSelectedAddress(fullAddress);
    setSearchAddressResults([]);
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    email: Yup.string()
      .email('Invalid email format')
      .test('email-or-mobile', 'Either email or mobile must be provided', function (value) {
        const { mobilePhone } = this.parent;
        return value || mobilePhone;
      }),
    mobilePhone: Yup.string()
      .test('email-or-mobile', 'Either email or mobile must be provided', function (value) {
        const { email } = this.parent;
        return value || email;
      }),
  });

  const searchContacts = React.useCallback(async (mobile, email, source) => {
    if ((source === 'mobile' && mobile && mobile.length > 3) || (source === 'email' && email && email.length > 5)) {
      if (source === 'mobile') {
        setIsSearchingMobile(true);
      } else if (source === 'email') {
        setIsSearchingEmail(true);
      }

      try {
        const contacts = await getContactsByCommunicationDetail(mobile, email, source);
        if (contacts.data && contacts.data.length > 0) {
          if (source === 'email') {
            setContactResultsEmail(contacts.data);
          } else {
            setContactResultsMobile(contacts.data);
          }
        } else {
          setContactResultsMobile([]);
          setContactResultsEmail([]);
        }
      } catch (error) {
       
        setContactResultsMobile([]);
        setContactResultsEmail([]);
      } finally {
        if (source === 'mobile') {
          setIsSearchingMobile(false);
        } else if (source === 'email') {
          setIsSearchingEmail(false);
        }
      }
    } else {
      if (source === 'mobile') {
        setContactResultsMobile([]);
      } else if (source === 'email') {
        setContactResultsEmail([]);
      }
    }
  }, []);

  const resetAndClearForm = (resetForm) => {
    resetForm();
    setselectedfeedbackId({ feedbackId: 0 });
    setselectedContactID({ contactId: 0 });
    setAttendeeOwnPropertyAddressExtraFields({
      attendeeOwnPropertyAddress: '',
      attendeeOwnPropertyAddressExcludeSuburbState: '',
      attendeeOwnPropertyLatitude: '',
      attendeeOwnPropertyLongitude: '',
      attendeeOwnPropertyPostcode: '',
      attendeeOwnPropertyState: '',
      attendeeOwnPropertyStreetName: '',
      attendeeOwnPropertyStreetNameExcludeSuburbState: '',
      attendeeOwnPropertySuburb: '',
      attendeeOwnPropertyUnitAndStreetNumber: '',
    });
    setSelectedAttendee(null);
    setSelectedAddress('');
    clearEditing();
    location.reload();
  };
   

    const clearEditing = () => {
      navigate(location.pathname, {
        state: {
          ...location.state,
          isEditing: false,
          attendeeDetails: null,
          selectedOpenhome: selectedOpenhome,
        },
        replace: true, 
      });
    };


  const handleSubmits = async (values, { resetForm }) => {
    setIsSubmitting(true);
    try {
      const JSONbody = {
        ...values,
        ...attendeeOwnPropertyAddressExtraFields,
        ...extraOpentimeDetails,
        ...selectedcontactID,
        ...selectedfeedbackId,
      };
       const responseOFI = await postOFIAttendee(JSONbody, openTimeDetails?.propertyopentimeid);
        const statusSuccessful = responseOFI >= 200 && responseOFI < 300;
        if (statusSuccessful) {
          alert("Attendee added successfully");
            resetAndClearForm(resetForm);
        } 
      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
      alert('Error saving attendee, please try again.');
    }
  };

  return (
    <Box sx={{ maxWidth: 800, margin: 'auto', padding: 2 }} ref={scrollViewRef}> {/* Apply ref to scrollable Box */}
      <Formik
        initialValues={{
        firstName: selectedAttendee?.firstname || selectedAttendee?.firstName || '',
        lastName: selectedAttendee?.lastname || selectedAttendee?.lastName || '',
        email: selectedAttendee?.email || '',
        mobilePhone: selectedAttendee?.mobilephone?.trim() || '',
        homePhone: selectedAttendee?.homephone?.trim() || '',
        workPhone: selectedAttendee?.workphone?.trim() || '',
        feedback: selectedAttendee?.feedback || '',
        interested: selectedAttendee?.interested ? 1 : 0,
        homeLoan: selectedAttendee?.homeloan ? 1 : 0,
        visitCount: selectedAttendee?.visitcount || 0,
        interestLevel: selectedAttendee?.interestlevel?.trim() ? parseInt(selectedAttendee?.interestlevel) : 0,
        contractRequested: selectedAttendee?.contractrequested ? 1 : 0,
        requestFloorplan: selectedAttendee?.requestfloorplan ? 1 : 0,
        requestVideolink: selectedAttendee?.requestvideolink ? 1 : 0,
        requestContract: selectedAttendee?.requestContract ? 1 : 0,
        requestPropertyReport: selectedAttendee?.requestPropertyReport ? 1 : 0,
        requestAreaUpdate: selectedAttendee?.requestAreaUpdate ? 1 : 0,
        requestPestReport: selectedAttendee?.requestPestReport ? 1 : 0,
        requestValuation: selectedAttendee?.requestValuation ? 1 : 0,
        requestBuildingReport: selectedAttendee?.requestBuildingReport ? 1 : 0,
        requestAppraisalReport: selectedAttendee?.requestAppraisalReport ? 1 : 0,
        requestStrataReport: selectedAttendee?.requestStrataReport ? 1 : 0,
        requestTenancyApplication: selectedAttendee?.requestTenancyApplication ? 1 : 0,
        requestTaxDepreciation: selectedAttendee?.requestTaxDepreciation ? 1 : 0,
        requestFairtradingReport: selectedAttendee?.requestFairtradingReport ? 1 : 0,
        requestGeneralInformation: selectedAttendee?.requestGeneralInformation ? 1 : 0,
        requestRecentSales: selectedAttendee?.requestRecentSales ? 1 : 0,
        requestPreview: selectedAttendee?.requestPreview ? 1 : 0,
        requestOfferForm: selectedAttendee?.requestOfferForm ? 1 : 0,
        requestStrataInformation: selectedAttendee?.requestStrataInformation ? 1 : 0,
        requestCodeOfComplianceCert: selectedAttendee?.requestCodeOfComplianceCert ? 1 : 0,
        requestCouncilfiles: selectedAttendee?.requestCouncilfiles ? 1 : 0,
        requestRatesInformation: selectedAttendee?.requestratesInformation ? 1 : 0,
        requestSubdivisionAndschemeplans: selectedAttendee?.requestsubdivisionAndschemeplans ? 1 : 0,
        requestSwimmingPool: selectedAttendee?.requestSwimmingPool ? 1 : 0,
        ownsProperty: selectedAttendee?.ownsProperty ? 1 : 0,
        requestOwnValuation: selectedAttendee?.requestOwnValuation ? 1 : 0,
        priceFeedbackFrom: String(selectedAttendee?.priceFeedbackFrom || ''),
        priceFeedbackTo: String(selectedAttendee?.priceFeedbackTo || ''),
        enableBroadcasting: selectedAttendee?.enableBroadcasting ? 1 : 0,
        feedbackType: 'inspection',
        title: selectedAttendee?.title || '',
        titleId: selectedAttendee?.titleid || '',
        agentNotes: selectedAttendee?.agentnotes || '',
        agentNotesToClient: selectedAttendee?.agentnotesToClient || ''
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmits}
      >
        {({ handleChange, handleBlur, handleSubmit, values, errors, touched, setFieldValue, resetForm }) => {
      
          return (
            <Box>
              {/* Property Image with Address Overlay */}
             

              <Box sx={{ padding: 2 }}>
                {/* Mobile Input */}
                <TextField
                  label="Mobile"
                  value={values.mobilePhone}
                  onChange={(e) => {
                    setFieldValue('mobilePhone', e.target.value);
                    searchContacts(e.target.value, e.target.value, 'mobile');
                  }}
                  onBlur={(e) => {
                    handleBlur('mobilePhone')(e);
                  }}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  error={touched.mobilePhone && Boolean(errors.mobilePhone)}
                  helperText={touched.mobilePhone && errors.mobilePhone}
                />
                {values.mobilePhone && values.mobilePhone.length > 5 && selectedcontactID.contactId === 0 ? (
                  <Box sx={{ mt: 1 }}>
                    {isSearchingMobile && (
                      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <CircularProgress size={24} />
                        <Typography variant="body2" sx={{ mt: 1, color: '#555' }}>Searching contacts…</Typography>
                      </Box>
                    )}
                    {contactResultsMobile.length > 0 && !isSearchingMobile && (
                      <Card sx={{ borderRadius: 2, boxShadow: 3, bgcolor: '#f5f5f5', mt: 1 }}>
                        <CardContent>
                          {contactResultsMobile.map((item) => (
                            <Button
                              key={`${item.contactid}-${item.firstname}`}
                              onClick={() => {
                                setFieldValue('firstName', item.firstname?.trim() || '');
                                setFieldValue('lastName', item.lastname?.trim() || '');
                                setFieldValue('mobilePhone', item.mobile?.trim() || '');
                                setFieldValue('workPhone', item.workphone?.trim() || '');
                                setFieldValue('homePhone', item.homephone?.trim() || '');
                                setFieldValue('email', item.email?.trim() || '');
                                setselectedContactID({ contactId: item.contactid });
                                setContactResultsMobile([]);
                              }}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                                py: 1.5,
                                px: 2,
                                mb: 1.5,
                                bgcolor: '#f9f9f9',
                                borderRadius: 2.5,
                                boxShadow: 1,
                                textTransform: 'none',
                                color: 'inherit',
                                '&:hover': { bgcolor: '#e0e0e0' }
                              }}
                            >
                              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <Typography variant="h6" sx={{ fontWeight: '400' }}>
                                  <AccountCircleIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} />
                                  {item.firstname} {item.lastname}
                                </Typography>
                                {item.mobile && (
                                  <Typography variant="body2" sx={{ color: '#555', mt: 0.5 }}>
                                    <PhoneAndroidIcon sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 16 }} />
                                    {item.mobile}
                                  </Typography>
                                )}
                                {item.email && (
                                  <Typography variant="body2" sx={{ color: '#555', mt: 0.5 }}>
                                    <EmailIcon sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 16 }} />
                                    {item.email}
                                    {item.emailVerified === 1 && (
                                      <AccountCircleIcon sx={{ verticalAlign: 'middle', ml: 0.5, color: 'green' }} />
                                    )}
                                  </Typography>
                                )}
                                {item.agentfirstname && item.agentlastname && (
                                  <Typography variant="body2" sx={{ color: '#555', mt: 0.5 }}>
                                    <BusinessCenterIcon sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 16 }} />
                                    {item.agentfirstname} {item.agentlastname}
                                  </Typography>
                                )}
                              </Box>
                              <Box>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    bgcolor:
                                      item.contactstatusid === 1
                                        ? 'green'
                                        : item.contactstatusid === 2
                                          ? 'orange'
                                          : 'red',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    px: 1.2,
                                    py: 0.5,
                                  }}
                                >
                                  {item.contactstatusid === 1
                                    ? 'Current'
                                    : item.contactstatusid === 2
                                      ? 'Archived'
                                      : 'Deleted'}
                                </Typography>
                              </Box>
                            </Button>
                          ))}
                        </CardContent>
                      </Card>
                    )}
                    {!isSearchingMobile && contactResultsMobile?.length === 0 && (
                      <Card sx={{ borderRadius: 2, boxShadow: 3, bgcolor: '#f5f5f5', mt: 1 }}>
                        <CardContent>
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 2.5 }}>
                            <SearchOffIcon sx={{ fontSize: 48, color: '#ccc' }} />
                            <Typography variant="body1" sx={{ color: '#666', mt: 1.2, textAlign: 'center' }}>
                              No contacts found
                            </Typography>
                          </Box>
                        </CardContent>
                      </Card>
                    )}
                  </Box>
                ) : null}

                {/* Email Input */}
                <TextField
                  label="Email"
                  value={values.email}
                  onChange={(e) => {
                    setFieldValue('email', e.target.value);
                    searchContacts(e.target.value, e.target.value, 'email');
                  }}
                  onBlur={(e) => {
                    handleBlur('email')(e);
                  }}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  type="email"
                  sx={{ mt: 1 }}
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                />
                {values.email && values.email.length > 5 && selectedcontactID.contactId === 0 ? (
                  <Box sx={{ mt: 1 }}>
                    {isSearchingEmail && (
                      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <CircularProgress size={24} />
                        <Typography variant="body2" sx={{ mt: 1, color: '#555' }}>Searching contacts…</Typography>
                      </Box>
                    )}
                    {contactResultsEmail.length > 0 && !isSearchingEmail && (
                      <Card sx={{ borderRadius: 2, boxShadow: 3, bgcolor: '#f5f5f5', mt: 1 }}>
                        <CardContent>
                          {contactResultsEmail.map((item) => (
                            <Button
                              key={`${item.contactid}-${item.firstname}`}
                              onClick={() => {
                                setFieldValue('firstName', item.firstname || '');
                                setFieldValue('lastName', item.lastname || '');
                                setFieldValue('mobilePhone', item.mobile || '');
                                setFieldValue('workPhone', item.workphone || '');
                                setFieldValue('homePhone', item.homephone || '');
                                setFieldValue('email', item.email || '');
                                setselectedContactID({ contactId: item.contactid });
                                setContactResultsEmail([]);
                              }}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                                py: 1.5,
                                px: 2,
                                mb: 1.5,
                                bgcolor: '#f9f9f9',
                                borderRadius: 2.5,
                                boxShadow: 1,
                                textTransform: 'none',
                                color: 'inherit',
                                '&:hover': { bgcolor: '#e0e0e0' }
                              }}
                            >
                              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <Typography variant="h6" sx={{ fontWeight: '400' }}>
                                  <AccountCircleIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} />
                                  {item.firstname} {item.lastname}
                                </Typography>
                                {item.mobile && (
                                  <Typography variant="body2" sx={{ color: '#555', mt: 0.5 }}>
                                    <PhoneAndroidIcon sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 16 }} />
                                    {item.mobile}
                                  </Typography>
                                )}
                                {item.email && (
                                  <Typography variant="body2" sx={{ color: '#555', mt: 0.5 }}>
                                    <EmailIcon sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 16 }} />
                                    {item.email}
                                    {item.emailVerified === 1 && (
                                      <AccountCircleIcon sx={{ verticalAlign: 'middle', ml: 0.5, color: 'green' }} />
                                    )}
                                  </Typography>
                                )}
                                {item.agentfirstname && item.agentlastname && (
                                  <Typography variant="body2" sx={{ color: '#555', mt: 0.5 }}>
                                    <BusinessCenterIcon sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 16 }} />
                                    {item.agentfirstname} {item.agentlastname}
                                  </Typography>
                                )}
                              </Box>
                              <Box>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    bgcolor:
                                      item.contactstatusid === 1
                                        ? 'green'
                                        : item.contactstatusid === 2
                                          ? 'orange'
                                          : 'red',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    px: 1.2,
                                    py: 0.5,
                                  }}
                                >
                                  {item.contactstatusid === 1
                                    ? 'Current'
                                    : item.contactstatusid === 2
                                      ? 'Archived'
                                      : 'Deleted'}
                                </Typography>
                              </Box>
                            </Button>
                          ))}
                        </CardContent>
                      </Card>
                    )}
                    {!isSearchingEmail && contactResultsEmail?.length === 0 && (
                      <Card sx={{ borderRadius: 2, boxShadow: 3, bgcolor: '#f5f5f5', mt: 1 }}>
                        <CardContent>
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 2.5 }}>
                            <SearchOffIcon sx={{ fontSize: 48, color: '#ccc' }} />
                            <Typography variant="body1" sx={{ color: '#666', mt: 1.2, textAlign: 'center' }}>
                              No contacts found
                            </Typography>
                          </Box>
                        </CardContent>
                      </Card>
                    )}
                  </Box>
                ) : null}

                {/* First Name */}
                <TextField
                  label="First Name"
                  value={values.firstName}
                  onChange={handleChange('firstName')}
                  onBlur={handleBlur('firstName')}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  required
                  error={touched.firstName && Boolean(errors.firstName)}
                  helperText={touched.firstName && errors.firstName}
                />
                {/* Last Name */}
                <TextField
                  label="Last Name"
                  value={values.lastName}
                  onChange={handleChange('lastName')}
                  onBlur={handleBlur('lastName')}
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  required
                  error={touched.lastName && Boolean(errors.lastName)}
                  helperText={touched.lastName && errors.lastName}
                />
                {selectedcontactID.contactId > 0 && (
                  <Box sx={{ mt: 2 }}>
                  <Accordion expanded={isInpectionHistory} onChange={() => setIsInspectionHistory(!isInpectionHistory)}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="inspectionHistory-content"
                      id="inspectionHistory-header"
                      >
                      <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                        Inspection History
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>           
                        <ContactInspectionCard contactId={selectedcontactID.contactId} />
                    </AccordionDetails>
                  </Accordion>
                  </Box>
                )}

                {/* Send me documents section */}
                <Box sx={{ mt: 2 }}>
                  <Accordion expanded={isSendingDoc} onChange={() => setIsSendingDoc(!isSendingDoc)}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="senddoc-content"
                    id="senddoc-header"
                  >
                    <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                       Send documents
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ mt: 2 }}> {/* This is the Box that needed a closing tag */}
                      {/* Checkboxes for documents */}
                      {openTimeDetails?.show_contractrequested === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.contractRequested === 1}
                              onChange={() => setFieldValue('contractRequested', values.contractRequested === 1 ? 0 : 1)}
                            />
                          }
                          label="Contract"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestfloorplan === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestFloorplan === 1}
                              onChange={() => setFieldValue('requestFloorplan', values.requestFloorplan === 1 ? 0 : 1)}
                            />
                          }
                          label="Floor Plan"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestvideolink === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestVideolink === 1}
                              onChange={() => setFieldValue('requestVideolink', values.requestVideolink === 1 ? 0 : 1)}
                            />
                          }
                          label="Video Link"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestpropertyreport === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestPropertyReport === 1}
                              onChange={() => setFieldValue('requestPropertyReport', values.requestPropertyReport === 1 ? 0 : 1)}
                            />
                          }
                          label="Property Report"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestareaupdate === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestAreaUpdate === 1}
                              onChange={() => setFieldValue('requestAreaUpdate', values.requestAreaUpdate === 1 ? 0 : 1)}
                            />
                          }
                          label="Area Update"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestpestreport === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestPestReport === 1}
                              onChange={() => setFieldValue('requestPestReport', values.requestPestReport === 1 ? 0 : 1)}
                            />
                          }
                          label="Pest Report"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestvaluation === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestValuation === 1}
                              onChange={() => setFieldValue('requestValuation', values.requestValuation === 1 ? 0 : 1)}
                            />
                          }
                          label="Valuation"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestbuildingreport === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestBuildingReport === 1}
                              onChange={() => setFieldValue('requestBuildingReport', values.requestBuildingReport === 1 ? 0 : 1)}
                            />
                          }
                          label="Building Report"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestappraisalreport === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestAppraisalReport === 1}
                              onChange={() => setFieldValue('requestAppraisalReport', values.requestAppraisalReport === 1 ? 0 : 1)}
                            />
                          }
                          label="Appraisal Report"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requeststratareport === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestStrataReport === 1}
                              onChange={() => setFieldValue('requestStrataReport', values.requestStrataReport === 1 ? 0 : 1)}
                            />
                          }
                          label="Strata Report"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestTenancyApplication === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestTenancyApplication === 1}
                              onChange={() => setFieldValue('requestTenancyApplication', values.requestTenancyApplication === 1 ? 0 : 1)}
                            />
                          }
                          label="Tenancy Application"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requesttaxdepreciation === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestTaxDepreciation === 1}
                              onChange={() => setFieldValue('requestTaxDepreciation', values.requestTaxDepreciation === 1 ? 0 : 1)}
                            />
                          }
                          label="Tax Depreciation"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestfairtradingreport === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestFairtradingReport  === 1}
                              onChange={() => setFieldValue('requestFairtradingReport', values.requestFairtradingReport === 1 ? 0 : 1)}
                            />
                          }
                          label="Fair Trading Report"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestgeneralinformation === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestGeneralInformation === 1}
                              onChange={() => setFieldValue('requestGeneralInformation', values.requestGeneralInformation === 1 ? 0 : 1)}
                            />
                          }
                          label="General Information"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestrecentsales === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestRecentSales === 1}
                              onChange={() => setFieldValue('requestRecentSales', values.requestRecentSales === 1 ? 0 : 1)}
                            />
                          }
                          label="Recent Sales"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestpreview === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestPreview === 1}
                              onChange={() => setFieldValue('requestPreview', values.requestPreview === 1 ? 0 : 1)}
                            />
                          }
                          label="Preview"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestofferform === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestOfferForm === 1}
                              onChange={() => setFieldValue('requestOfferForm', values.requestOfferForm === 1 ? 0 : 1)}
                            />
                          }
                          label="Offer Form"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requeststratainformation === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestStrataInformation === 1}
                              onChange={() => setFieldValue('requestStrataInformation', values.requestStrataInformation === 1 ? 0 : 1)}
                            />
                          }
                          label="Strata Information"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {/* Added missing show_ properties below this point to ensure all checkboxes are conditional */}
                      {openTimeDetails?.show_requestCodeOfComplianceCert === 1 && (
                        <FormControlLabel
                          control={<Switch checked={values.requestCodeOfComplianceCert === 1} onChange={() => setFieldValue('requestCodeOfComplianceCert', values.requestCodeOfComplianceCert === 1 ? 0 : 1)} />}
                          label="Code of Compliance Cert"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestCouncilfiles === 1 && (
                        <FormControlLabel
                          control={<Switch checked={values.requestCouncilfiles === 1} onChange={() => setFieldValue('requestCouncilfiles', values.requestCouncilfiles === 1 ? 0 : 1)} />}
                          label="Council Files"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestratesInformation === 1 && (
                        <FormControlLabel
                          control={<Switch checked={values.requestRatesInformation === 1} onChange={() => setFieldValue('requestRatesInformation', values.requestRatesInformation === 1 ? 0 : 1)} />}
                          label="Rates Information"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestsubdivisionAndschemeplans === 1 && (
                        <FormControlLabel
                          control={<Switch checked={values.requestSubdivisionAndschemeplans === 1} onChange={() => setFieldValue('requestSubdivisionAndschemeplans', values.requestSubdivisionAndschemeplans === 1 ? 0 : 1)} />}
                          label="Subdivision & Scheme Plans"
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      {openTimeDetails?.show_requestSwimmingPool === 1 && (
                        <FormControlLabel
                          control={<Switch checked={values.requestSwimmingPool === 1} onChange={() => setFieldValue('requestSwimmingPool', values.requestSwimmingPool === 1 ? 0 : 1)} />}
                          label="Swimming Pool"
                          sx={{ mb: 1.5 }}
                        />
                      )}

                      <FormControlLabel
                        control={
                          <Switch
                            checked={values.homeLoan === 1}
                            onChange={() => setFieldValue('homeLoan', values.homeLoan === 1 ? 0 : 1)}
                          />
                        }
                        label="Need a home loan?"
                        sx={{ mb: 1.5, mt: 2 }}
                      />
                    </Box> 
                 </AccordionDetails>
                </Accordion>
                </Box>


                {/* Attendee Feedback Section */}
                <Box sx={{ mt: 2 }}>
                  <Accordion expanded={isFeedback} onChange={() => setIsFeedback(!isFeedback)}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="feedback-content"
                    id="feedback-header"
                  >
                    <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                      Feedback
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ mt: 2 }}> {/* This is the Box that needed a closing tag */}
                      <FormControlLabel
                        control={
                          <Switch
                            checked={values.interested === 1}
                            onChange={() => setFieldValue('interested', values.interested === 1 ? 0 : 1)}
                          />
                        }
                        label="Are you interested?"
                        sx={{ mb: 1.5 }}
                      />

                      {values.interested === 1 && (
                        <RadioGroup
                          value={String(values.interestLevel)}
                          onChange={(event) => setFieldValue('interestLevel', parseInt(event.target.value))}
                        >
                          <FormControlLabel value="3" control={<Radio />} label="Very Interested" />
                          <FormControlLabel value="2" control={<Radio />} label="Interested" />
                          <FormControlLabel value="1" control={<Radio />} label="Somewhat Interested" />
                          <FormControlLabel value="0" control={<Radio />} label="Not Interested" />
                        </RadioGroup>
                      )}

                      {/* Owns Property */}
                      <FormControlLabel
                        control={
                          <Switch
                            checked={values.ownsProperty === 1}
                            onChange={() => setFieldValue('ownsProperty', values.ownsProperty === 1 ? 0 : 1)}
                          />
                        }
                        label="Do you own a property?"
                        sx={{ mb: 1.5 }}
                      />
                      {values.ownsProperty === 1 && (
                        <Box sx={{ mb: 2 }}>
                          {/* Unit / Street Number Input */}
                          <TextField
                            label="Unit / Street Number"
                            value={values.unitNumber}
                            onChange={handleChange('unitNumber')}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                          />

                          {/* Street Name and Suburb Input */}
                          <TextField
                            label={addressLabel}
                            value={selectedAddress || values.addressKeyword}
                            onChange={(e) => {
                              setFieldValue('addressKeyword', e.target.value);
                              searchAddressViaMapbox(e.target.value);
                            }}
                            onBlur={handleBlur('addressKeyword')}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                          />

                          {isSearchingMapbox && (
                            <Box sx={{ p: 1.2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                              <CircularProgress size={24} />
                              <Typography variant="body2" sx={{ mt: 0.8, color: '#555' }}>Searching addresses…</Typography>
                            </Box>
                          )}
                          {searchAddressResults.length > 0 && !isSearchingMapbox && (
                            <Card sx={{ bgcolor: '#f5f5f5', borderRadius: 2, boxShadow: 3, mt: 1 }}>
                              <CardContent>
                                {searchAddressResults.map((item) => (
                                  <Button
                                    key={item.id}
                                    onClick={() => populateAttendeeOwnPropertyAddressExtraFields(item.properties, values.unitNumber)}
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'flex-start',
                                      width: '100%',
                                      py: 1,
                                      px: 2,
                                      mb: 1.5,
                                      bgcolor: '#f9f9f9',
                                      borderRadius: 2.5,
                                      boxShadow: 1,
                                      textTransform: 'none',
                                      color: 'inherit',
                                      '&:hover': { bgcolor: '#e0e0e0' }
                                    }}
                                  >
                                    <Typography variant="body1" sx={{ fontWeight: '600' }}>
                                      <MapIcon sx={{ verticalAlign: 'middle', mr: 0.5 }} />
                                      {item.properties.full_address}
                                    </Typography>
                                  </Button>
                                ))}
                              </CardContent>
                            </Card>
                          )}
                          {!isSearchingMapbox && searchAddressResults?.length === 0 && values.addressKeyword && values.addressKeyword.length > 3 && (
                            <Card sx={{ borderRadius: 2, boxShadow: 3, bgcolor: '#f5f5f5', mt: 1 }}>
                              <CardContent>
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 2.5 }}>
                                  <SearchOffIcon sx={{ fontSize: 48, color: '#ccc' }} />
                                  <Typography variant="body1" sx={{ color: '#666', mt: 1.2, textAlign: 'center' }}>
                                    No Address found
                                  </Typography>
                                </Box>
                              </CardContent>
                            </Card>
                          )}
                        </Box>
                      )}

                      {values.ownsProperty === 1 && (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.requestOwnValuation === 1}
                              onChange={() => setFieldValue('requestOwnValuation', values.requestOwnValuation === 1 ? 0 : 1)}
                            />
                          }
                          label="Would you like a free Corelogic Valuation Report?"
                          sx={{ mb: 1.5 }}
                        />
                      )}

                      <TextField
                        label="Attendee Feedback"
                        value={values.feedback}
                        onChange={(e) => setFieldValue('feedback', e.target.value)}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        multiline
                        rows={4}
                      />

                      <TextField
                        label="Price Feedback From"
                        value={values.priceFeedbackFrom}
                        onChange={(e) => setFieldValue('priceFeedbackFrom', e.target.value)}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                      />
                      <TextField
                        label="Price Feedback To"
                        value={values.priceFeedbackTo}
                        onChange={(e) => setFieldValue('priceFeedbackTo', e.target.value)}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                      />

                      <TextField
                        label="Internal Agent Feedback"
                        value={values.agentNotes}
                        onChange={(e) => setFieldValue('agentNotes', e.target.value)}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        multiline
                        rows={4}
                      />

                      <TextField
                        label="Agent Notes To Client"
                        value={values.agentNotesToClient}
                        onChange={(e) => setFieldValue('agentNotesToClient', e.target.value)}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        multiline
                        rows={4}
                      />
                    </Box> 
                </AccordionDetails>
              </Accordion>
                </Box>


                {/* Stay in the know */}
                <Typography variant="h5" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                  Stay in the know <Typography component="span" sx={{ color: 'red' }}>*</Typography>
                </Typography>

                <Typography variant="body2" sx={{ mb: 2 }}>
                  Stay in the know with timely updates, property insights, and valuable information delivered directly to you. By opting in, you agree to receive these updates and acknowledge our
                  <Link href={disclaimerURL} target="_blank" rel="noopener noreferrer" sx={{ ml: 0.5, mr: 0.5 }}>
                    disclaimer
                  </Link>
                  and
                  <Link href={privatepolicyURL} target="_blank" rel="noopener noreferrer" sx={{ ml: 0.5 }}>
                    privacy policy
                  </Link>
                  .
                </Typography>

                <FormControlLabel
                  control={
                    <Switch
                      checked={values.enableBroadcasting === 1}
                      onChange={() => setFieldValue('enableBroadcasting', values.enableBroadcasting === 1 ? 0 : 1)}
                    />
                  }
                  label={values.enableBroadcasting === 1 ? 'Yes' : 'No'}
                  sx={{ mb: 2 }}
                />

                <Divider sx={{ my: 2 }} />

                {/* Clear and Submit Button */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 10 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<DeleteIcon />}
                    onClick={() => resetAndClearForm(resetForm)}
                    sx={{ width: '30%', mr: 2, bgcolor: 'grey.600', '&:hover': { bgcolor: 'grey.700' } }}
                  >
                    Clear
                  </Button>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
                    sx={{ width: '60%' }}
                  >
                    Submit
                  </Button>
                </Box>
              </Box>
            </Box>
          );
        }}
      </Formik>
    </Box>
  );
};

export default CheckinForm;